export default {
  visitList: {},
  visitDetail: {},
  visitTypeList: [],
  visitTeams: [],
  visitCustomerDataList: [],
  visitMedicalCustomerDataList: [],
  visitCustomerSalesmanDataList: [],
  visitCustomerConvertDataList: [],
  visitBusinessDataList: [],
  visitBusinessConvertDataList: [],
  visitCluesDataList: [],
};
